<style scoped>
.template-section-toolbar {
  display: flex;
  gap: 20px;
  padding: 10px;
  background: #c9d2e1;
}
</style>

<template>
  <div
    v-if="section && section.isEditingSettings"
    class="template-section-toolbar"
  >
    <v-btn
      v-if="section.sectionResources && section.sectionResources.length"
      @click="clearResourcesData(section)"
      x-small
      data-testid="template-section-toolbar--btn-clear-values"
    >
      <v-icon style="font-size: 12px; padding-top: 2px;">mdi-trash-can-outline</v-icon>
      <span class="d-none d-sm-flex" style="margin-left: 3px;">
        {{ translate('dialog_section_ui_btn_clear_resources_data') }}
      </span>
    </v-btn>

    <v-btn
      v-if="section.sectionResources && section.sectionResources.length"
      @click="generateResourcesData(section)"
      x-small
      data-testid="template-section-toolbar--btn-generate-values"
    >
      <v-icon style="font-size: 12px; padding-top: 2px;">mdi-dice-5-outline</v-icon>
      <span class="d-none d-sm-flex" style="margin-left: 3px;">
        {{ translate('dialog_section_ui_btn_generate_resources_data') }}
      </span>
    </v-btn>

    <v-btn
      v-if="selectedResourcesCount"
      x-small
      color="error"
      @click="deleteSelectedResources"
      data-testid="template-section-toolbar--btn-delete-resources"
    >
      <v-icon style="font-size: 12px; padding-top: 2px; margin-right: 3px;">mdi-trash-can-outline</v-icon>
      {{ translate('ui_delete_btn') }} {{ selectedResourcesCount }}
      <!--
      <span class="d-none d-sm-flex" style="margin-left: 3px;">
         {{ translate('ui_items_selected') }}
      </span>
      -->
    </v-btn>

    <v-btn
      v-if="section.sectionResources && section.sectionResources.length"
      x-small
      color="primary"
      style="background-color: #fff;"
      @click="addSectionResource(section, false)"
      data-testid="template-section-toolbar--btn-add-resource"
    >
      <v-icon style="font-size: 14px; padding-right: 5px;">mdi-plus</v-icon>
      {{ translate(section.addResourceLabel) }}
    </v-btn>

    <v-spacer/>

    <v-btn
        v-if="previewModule.canSkip"
        x-small
        @click="toggleModule(previewModule);"
        data-testid="template-section-toolbar--btn-disable-section"
    >
      <v-icon style="font-size: 16px; padding-top: 1px; margin-right: 3px;">mdi-toggle-switch</v-icon>
      <span class="d-none d-sm-flex">
        <span v-if="!previewModule.isEnabled">{{ translate('ui_enable_sheet_btn') }}</span>
        <span v-if="previewModule.isEnabled">{{ translate('ui_disable_sheet_btn') }}</span>
      </span>
    </v-btn>

  </div>
</template>
<script>
import Mixin from '@/mixins/mixin';

export default {
  name: 'TemplateSectionToolbar',
  mixins: [Mixin],
  props: {
    previewModule: Object,
  },
  data: () => ({}),
  computed: {
    section() {
      return this.getSectionById(this.previewModule.templateSectionCfg.id);
    },
    selectedResourcesCount() {
      return this.section.sectionResources && this.section.sectionResources.filter((resource) => resource.isSelected).length;
    },
  },
  methods: {
    deleteSelectedResources() {
      const sectionResourcesToDelete = this.section.sectionResources.filter((resource) => resource.isSelected);
      this.deleteResources(null, sectionResourcesToDelete);
      // this.section.sectionResources.forEach((resource) => {
      //   if (resource.isSelected) {
      //     this.deleteResource(null, resource);
      //   }
      // });
    },
  },
  mounted() {},
};
</script>
